import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import StudentInfo from "../../components/Cards/Student/Info";
import StudentRadarChart from "../../components/Cards/Student/RadarChart";
import CvCompetences from "../../components/Cards/Cv/Competences";
import CvJobs from "../../components/Cards/Cv/Jobs";
import CvLanguages from "../../components/Cards/Cv/Languages";
import CvOthers from "../../components/Cards/Cv/Others";
import CvQualifications from "../../components/Cards/Cv/Qualifications";
import {selectCv, selectUser} from "../../slices/profile";
import {selectUid} from "../../slices/auth";
import {StudentProfileTutorial} from "../../components/Dialog/StudentProfileTutorial";
import {Cookies} from "react-cookie-consent";
import {openDialog} from "../../slices/dialog";
import {StudentCvInterface} from "../../db/models/student/cv";
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {useHistory} from "react-router-dom";
import {ROUTES} from "../../db/models/const";

interface Props {
    topRef?: HTMLDivElement;
}

export const StudentProfile: React.FC<Props> = ({topRef}) => {
    const uid = useSelector(selectUid);
    const user = useSelector(selectUser);
    const cv: StudentCvInterface = useSelector(selectCv);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const history = useHistory();

    const ShowProfileTutorial = () => {
        const tutorialDone = Cookies.get("profileTutorialDone");
        if (!tutorialDone)
            dispatch(
                openDialog({
                    Content: StudentProfileTutorial,
                    title: "",
                    props: {},
                    closable: false,
                    narrow: true,
                })
            );
    }

    useEffect(() => {
        // reset sidebar profile button highlight if was applied after rm tutorial dialog was closed
        const elem: HTMLElement | null = document.getElementById(
            "studentSidebar_profile"
        );
        elem?.setAttribute("style", "");
    }, []);

    const goToFeed = () => Cookies.get("feedTutorialDone") ?
        history.push(ROUTES.FEED) :
        history.push(ROUTES.STUDENT_INTEREST)

    return (
        <div className="studentProfile">
            <h2 className="title">{t("student_profile_title")}</h2>
            <h3 className="subtitle">{t("student_profile_top_expl")}</h3>
            <div className="studentProfile__grid studentProfile__grid1">
                <div className={"h-100"}>
                    <StudentInfo student={user}/>
                </div>
                <div className={"d-md-none"}>
                    <Button className={"oval-borders w-100 p-3"} size={"lg"}
                            variant={"success"}
                            onClick={goToFeed}
                    >{t("student_profile_button_to_opportunities")}</Button>
                </div>
                <div>
                    <StudentRadarChart topRef={topRef}/>
                </div>
            </div>
            <h3 className="subtitle">{t("student_profile_cv_expl")}</h3>
            <div className="studentProfile__grid studentProfile__grid2">
                <CvQualifications
                    editable={true}
                    qualifications={Object.values(cv?.bg?.qualifications || {})}
                    docId={uid}
                />
                <CvJobs
                    editable={true}
                    jobs={Object.values(cv?.bg?.jobs || {})}
                    docId={uid}
                />
                <CvCompetences
                    editable={true}
                    competences={Object.values(cv?.bg?.competences || {})}
                    docId={uid}
                />
                <CvLanguages
                    editable={true}
                    languages={Object.values(cv?.bg?.languages || {})}
                    docId={uid}
                />
                <CvOthers
                    editable={true}
                    others={Object.values(cv?.bg?.others || {})}
                    docId={uid}
                />
            </div>
            {/* <Tour
				steps={tourSteps}
				isOpen={isTourOpen}
				onRequestClose={() => setIsTourOpen(false)}
			/> */}
        </div>
    );
};
